

import templateProductListPage from '@/app-template/lib/pages/ProductListPage.vue';

export default {
  name: "ProductListPage",
  components: { templateProductListPage },
};
